var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('a',{attrs:{"href":_vm.link,"title":_vm.name}},[_c('img',{attrs:{"src":_vm.content}}),_c('h3',[_vm._v(_vm._s(_vm.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }